export const WHATS_NEW_FEATURE = 'whats_new'
